import React, { useContext, useEffect, useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import { ApiContext } from '@api/api.tsx';
import { LovWithoutIdDTO, ShipmentStateCodeEnum } from '@api/ringil-api.v2.tsx';
import InputShipmentStatus from '@components/obsolete/Form/InputShipmentStatus/InputShipmentStatus.tsx';
import SvgFlag from '@icons/Flag.tsx';

interface ComponentProps {
  secured?: SecuredConfig;
  code: ShipmentStateCodeEnum;
  onChange: (code: ShipmentStateCodeEnum) => void;
  required?: boolean;
  readOnly?: boolean;
  dataTestId?: string;
}

const ShipmentStatusTag: React.FC<ComponentProps> = ({ secured, code, onChange, required, readOnly, dataTestId }) => {
  const { tr } = useTranslationLgs();
  const { lovShipmentStateStatus } = useContext(ApiContext);
  const [statuses, setStatuses] = useState<LovWithoutIdDTO[]>([]);
  const [internalValue, setInternalValue] = useState(code);

  useEffect(() => {
    lovShipmentStateStatus(d => setStatuses(d));
  }, []);

  useEffect(() => setInternalValue(code), [code]);

  const name = statuses.find(s => s.code === code)?.name;

  return (
    <ButtonTag
      secured={secured}
      label={tr('ShipmentStatusTag.label', 'Shipment state')}
      icon={<SvgFlag />}
      value={name}
      required={required}
      readonly={readOnly}
      onSave={onSuccess => {
        onChange(internalValue);
        onSuccess();
      }}
      autoClose
      dataTestId={dataTestId}
    >
      <InputShipmentStatus code={internalValue} onChange={v => setInternalValue(v)} required={required} options={statuses} />
    </ButtonTag>
  );
};

export default ShipmentStatusTag;
